import React from "react";
import { Module } from "../../components";
import {
  CoberturasEAssistencias,
  HomePage,
  ResultadoDosSorteios,
  DuvidasFrequentes,
  CondicoesGeraisPage,
  ManualDeAssistencia,
  CondicoesGeraisSeguroResidencial,
  CondicoesGeraisSeguroFacilResidencial,
  CondicoesGeraisSeguroCompreensivo,
} from "./Pages";

const Residencial = () => {
  return (
    <Module moduleName="Seguro Residencial">
      <Module.Page
        path="/coberturas-e-assistencias"
        page={CoberturasEAssistencias}
        title="Coberturas e assistências"
        description="Veja quais e como funcionam as coberturas e assistências do seu Seguro Residencial."
      />

      <Module.Page
        path="/duvidas-frequentes"
        page={DuvidasFrequentes}
        title="Dúvidas frequentes"
        description="Separamos algumas dúvidas e questionamentos mais comuns que nossos clientes fazem."
      />

      <Module.Page
        path="/condicoes-gerais"
        page={CondicoesGeraisPage}
        title="Condições gerais"
        description="Baixe as condições gerais do seu produto."
      />

      <Module.Page
        path="/condicoes-gerais/seguro-residencial"
        page={CondicoesGeraisSeguroResidencial}
        title="Seguro Residencial"
        parentPage="/condicoes-gerais"
        disableNavigation
      />

      <Module.Page
        path="/condicoes-gerais/seguro-facil-residencial"
        page={CondicoesGeraisSeguroFacilResidencial}
        title="Seguro Fácil Residencial"
        parentPage="/condicoes-gerais"
        disableNavigation
      />

      <Module.Page
        path="/condicoes-gerais/seguro-compreensivo-de-imoveis"
        page={CondicoesGeraisSeguroCompreensivo}
        title="Seguro Compreensivo de Imóveis"
        parentPage="/condicoes-gerais"
        disableNavigation
      />

      <Module.Page
        path="/manual-de-assistencias"
        page={ManualDeAssistencia}
        title="Manual de assistência"
        description="Consulte todos os serviços de assistência que estão disponíveis para o seu Seguro Residencial."
      />
      <Module.Page
        path="/resultado-dos-sorteios"
        page={ResultadoDosSorteios}
        title="Resultado dos sorteios"
        description="Consulte os últimos resultados dos sorteios mensais do Seguro Residencial (simplificado). Boa sorte!"
      />
      <Module.Page path="/" page={HomePage} title="Página Seguro Residencial" />
    </Module>
  );
};

Residencial.propTypes = {};

export default Residencial;
